<div class="offering-onboarding-steps">
  <h1 class="ui-heading-1-bold">
    {{ section() }}
  </h1>

  <p class="ui-body-l">{{ onboardingAccessInstructions() }}</p>

  @for (onboardingStep of onboardingSteps(); track $index) {
    <rds-basic-card layout="horizontal">
      <rds-card-header>
        <rds-card-title>
          <span class="ui-heading-3">Step {{ $index + 1 }}</span>
        </rds-card-title>
      </rds-card-header>
      <rds-card-content>
        <div class="offering-onboarding-steps-content">
          <p class="ui-body-l">
            {{ onboardingStep.description }}
          </p>
          <a
            class="link"
            rds-link
            standalone
            [href]="onboardingStep.referenceUrl"
            target="_blank"
          >
            {{ BUTTONS.CLICK_HERE }}
            <rds-icon namespace="filled" icon="arrow_right" />
          </a>
        </div>
      </rds-card-content>
    </rds-basic-card>
  }
</div>
